const quantityBarSelector = '#product-quantity-bar-block';
function attachListeners() {
  // On popout button click 
  document.querySelectorAll('.select-popout__item').forEach(item => {
    reRenderForm(item);
  });

  // On color swatch click 
  document.querySelectorAll('[data-is-color]').forEach(item => {
    reRenderForm(item);
  });

  // On radio button click 
  document.querySelectorAll('[data-variant-availability]').forEach(item => {
    reRenderForm(item);
  });
  function reRenderForm(item) {
    item.addEventListener('click', async function (event) {
      const variantId = item.getAttribute('data-variant-id');
      const productHandle = document.querySelector('#template-product').getAttribute('data-product-handle');
      const sectionId = document.querySelector('#template-product').getAttribute('data-section-id');
      const quantity = document.querySelector('.product-form .quantity__input').getAttribute('value');

      //Check if a view is in the URL, if it's the case we add it to the fetched URL
      let params = new URLSearchParams(document.location.search);
      let view = '';
      if (params.get("view") != null) {
        view = 'view=' + params.get("view") + '&';
      }

      // Fetch the new product infos, with the selected variant
      let response = await fetch(window.Shopify.routes.root + `products/${productHandle}?${view}variant=${variantId}&section_id=${sectionId}`);
      let content = await response.text();
      const newDiv = document.createElement("div");
      newDiv.innerHTML = content;

      // Replace HTML with the new one fetch in the call above
      document.querySelector('.title-price-rating').innerHTML = newDiv.querySelector('.title-price-rating').innerHTML;
      document.querySelector('.product-form').innerHTML = newDiv.querySelector('.product-form').innerHTML;

      // Keep the quantity set before the render
      document.querySelector('.product-form .quantity__input').setAttribute('value', quantity);

      // Use the Popout class (in the theme.dev.js), thanks to this, the size selector is re-init
      document.querySelectorAll('[data-popout]').forEach(popout => {
        new theme.Popout(popout);
      });

      // Re-init the quantity multiplicator
      if (document.querySelector('.culottes-multiplicator__container')) {
        theme.initProgressBar();
      }
      let section = {
        container: document.querySelector('#MainContent')
      };

      // Use the ProductAddFrom class (in the theme.dev.js), thanks to this the buttons and quantity are re-init
      new theme.ProductAddForm(section);

      // Use the Product class (in the theme.dev.js), thanks to this the drawer guides are re-init
      new theme.Product(section);

      // Use the ProductAlternative class (in the product-alternative-message.js), thanks to this the "out of stock message" is re-init
      if (document.querySelector('[data-alternative-collection]').getAttribute('data-alternative-collection') == "true") {
        new theme.ProductAlternative(section);
      }
      const currentUrl = new URL(window.location.href);
      // Replace variant parameter in the URL 
      currentUrl.searchParams.set('variant', variantId);
      // Replace url without reloading the page
      window.history.replaceState({}, '', currentUrl);

      // Re attach listener each time the size selector is updated
      attachListeners();
      displayQuickPay();
      updateBIS();
      wrapPriceTitle();
    });
  }
}

// Init function when content loaded
document.addEventListener('DOMContentLoaded', () => {
  attachListeners();
  updateBIS();
  displayQuickPay();
  wrapPriceTitle();

  // If the page is not reloaded
  const navEntries = performance.getEntriesByType('navigation');
  if (navEntries.length > 0 && navEntries[0].type === 'navigate') {
    // If the best seller is selected, click on it, avoid to have the incorrect id in the URL, and the wrong variant selected

    if (document.querySelector('[data-swatch-best-seller="true"]')) {
      document.querySelector('[data-swatch-best-seller="true"]').click();
    }
    if (document.querySelector('[data-radio-best-seller="true"]')) {
      document.querySelector('[data-radio-best-seller="true"]').click();
    }
  }
});
function updateBIS() {
  // Select all the option unavailable
  document.querySelectorAll('[data-variant-availability="false"] ~ svg').forEach(btn => {
    btn.addEventListener('click', () => {
      // Get the variant id
      let variantId = btn.closest('.radio__button__label-container').querySelector('label').getAttribute('data-variant-id');
      document.querySelector('#klaviyo-bis-trigger').click();

      // Change the value after a tiny timeout, to be sure that the iframe is currently displayed
      setTimeout(() => {
        let iframe = document.querySelector(`#klaviyo-bis-iframe`);
        let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        innerDoc.querySelector(`#variant_select [value="${variantId}"]`).setAttribute('selected', true);
      }, 250);
    });
  });

  // On click of the soldout atc btn 
  document.querySelector('#klaviyo-bis-trigger').addEventListener('click', () => {
    // Get the variant id
    let variantId = document.querySelector('input:checked~.radio__button__label-container label').getAttribute('data-variant-id');

    // Change the value after a tiny timeout, to be sure that the iframe is currently displayed
    setTimeout(() => {
      let iframe = document.querySelector(`#klaviyo-bis-iframe`);
      let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      innerDoc.querySelector(`#variant_select [value="${variantId}"]`).setAttribute('selected', true);
    }, 250);
  });
}
function displayQuickPay() {
  document.querySelectorAll('[data-variant-availability]').forEach(option => {
    option.addEventListener('click', () => {
      if (option.getAttribute('data-variant-availability') == "true") {
        document.querySelectorAll(`.product__submit__buttons just-pay-button, #product-sticky-atc__container just-pay-button`).forEach(justPayBtn => {
          justPayBtn.classList.add('just-pay-button--is-available');
        });
      } else {
        document.querySelectorAll(`.product__submit__buttons just-pay-button, #product-sticky-atc__container just-pay-button`).forEach(justPayBtn => {
          justPayBtn.classList.remove('just-pay-button--is-available');
        });
      }
    });
  });
}
function wrapPriceTitle() {
  let containerWidth = document.querySelector('.title-price-rating__title-container').clientWidth;
  let titleWidth = document.querySelector('.title-price-rating .product__h1title').clientWidth;
  let priceWidth = document.querySelector('[data-price-wrapper]').clientWidth;
  let emptySpace = containerWidth - titleWidth;
  if (emptySpace > priceWidth) {
    document.querySelector('.title-price-rating .product__price__wrap').classList.add('product__price__wrap--is-wrapped');
  } else {
    document.querySelector('.title-price-rating .product__price__wrap').classList.remove('product__price__wrap--is-wrapped');
  }
}
if (document.querySelector(quantityBarSelector)) {
  document.addEventListener('drawer:cart:refreshed', async () => {
    const productHandle = document.querySelector('#template-product').getAttribute('data-product-handle');
    const sectionId = document.querySelector('#template-product').getAttribute('data-section-id');

    // Check if a view is in the URL, if it's the case we add it to the fetched URL
    let params = new URLSearchParams(document.location.search);
    let view = '';
    if (params.get("view") != null) {
      view = '&view=' + params.get("view");
    }

    // Fetch the new product infos
    let response = await fetch(window.Shopify.routes.root + `products/${productHandle}?section_id=${sectionId}${view}`);
    let content = await response.text();
    const newDiv = document.createElement("div");
    newDiv.innerHTML = content;

    // Replace HTML with the quantity bar fetch in the call above
    document.querySelector(quantityBarSelector).innerHTML = newDiv.querySelector(quantityBarSelector).innerHTML;
  });
}